export default __webpack_public_path__ + "4ba49a4ee64fe484b853ff6f7e17d826.png";